var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table offer-info" },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.c_data } },
        [
          _c(
            "el-table",
            {
              ref: "table",
              staticStyle: { "margin-top": "15px" },
              attrs: {
                data: _vm.data,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _vm.c_canEdit
                ? _c("el-table-column", { attrs: { type: "selection" } })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: _vm.$t("ssrManage.invitationCode"),
                  width: "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          { attrs: { prop: `[${scope.$index}].supplierCode` } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: scope.row.supplierCode,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "supplierCode", $$v)
                                },
                                expression: "scope.row.supplierCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: _vm.$t("ssrManage.supplierNameShort"),
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].supplierNameShort`,
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: scope.row.supplierNameShort,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "supplierNameShort", $$v)
                                },
                                expression: "scope.row.supplierNameShort",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: _vm.$t("ssrManage.dc"),
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].warehouseName`,
                              rules: _vm.requiredRule,
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: !_vm.c_canEdit },
                              model: {
                                value: scope.row.warehouseName,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "warehouseName", $$v)
                                },
                                expression: "scope.row.warehouseName",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: _vm.$t("ssrManage.dcAddress"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].warehouseAddress`,
                              rules: _vm.requiredRule,
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: !_vm.c_canEdit },
                              model: {
                                value: scope.row.warehouseAddress,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "warehouseAddress", $$v)
                                },
                                expression: "scope.row.warehouseAddress",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: _vm.$t("ssrManage.nature"),
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].nature`,
                              rules: _vm.requiredRule,
                            },
                          },
                          [
                            _c("ic-select", {
                              attrs: {
                                table: "TT_SSR",
                                field: "LOGISTIC_NATURE",
                                disabled: !_vm.c_canEdit,
                              },
                              model: {
                                value: scope.row.nature,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "nature", $$v)
                                },
                                expression: "scope.row.nature",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    "show-overflow-tooltip": "",
                    label: _vm.$t("ssrManage.availablePalletNum"),
                    "header-align": "center",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("ssrManage.temperature_normal"),
                      width: "120",
                      disabled: !_vm.c_canEdit,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `[${scope.$index}].roomTemperaturePalletNumber`,
                                  rules: _vm.requiredRule,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { disabled: !_vm.c_canEdit },
                                  model: {
                                    value:
                                      scope.row.roomTemperaturePalletNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "roomTemperaturePalletNumber",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "scope.row.roomTemperaturePalletNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("ssrManage.temperature_cold"),
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `[${scope.$index}].refrigeratePalletNumber`,
                                  rules: _vm.requiredRule,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { disabled: !_vm.c_canEdit },
                                  model: {
                                    value: scope.row.refrigeratePalletNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "refrigeratePalletNumber",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "scope.row.refrigeratePalletNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("ssrManage.temperature_frozen"),
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `[${scope.$index}].freezePalletNumber`,
                                  rules: _vm.requiredRule,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { disabled: !_vm.c_canEdit },
                                  model: {
                                    value: scope.row.freezePalletNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "freezePalletNumber",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.freezePalletNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: _vm.$t("ssrManage.freeCarNumber"),
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].freeCarNumber`,
                              rules: _vm.requiredRule,
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: !_vm.c_canEdit },
                              model: {
                                value: scope.row.freeCarNumber,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "freeCarNumber", $$v)
                                },
                                expression: "scope.row.freeCarNumber",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: _vm.$t("ssrManage.outSourcingCarNumber"),
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].outSourcingCarNumber`,
                              rules: _vm.requiredRule,
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: !_vm.c_canEdit },
                              model: {
                                value: scope.row.outSourcingCarNumber,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "outSourcingCarNumber",
                                    $$v
                                  )
                                },
                                expression: "scope.row.outSourcingCarNumber",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }